import apiClient from "./apiClient";

export const loginUser = (
  email: string,
  password: string,
  rememberMe?: boolean,
) =>
  apiClient.post("/users/login", {
    email,
    password,
    rememberMe: rememberMe === true,
  });

export const getCurrentUser = async () => {
  const response = await apiClient.get("/users/me");
  return response.data;
};

export const getConnections = async () => {
  const response = await apiClient.get("/users/connections");
  return response.data;
};
